export const KEY9_MARKER_CLASS_NAMES = {
  cell: 'key9-cell',
  marker: 'key9-marker',
  locked: 'key9-locked',
  fullMode: 'key9-full-mode'
} as const;

export type Key9MarkerGeometry = {
  offsetX: number;
  offsetY: number;
  radius: number;
};

export function getKey9MarkerGeometry(cellSize: number): Key9MarkerGeometry {
  const radius = Math.max(2, Math.round(cellSize * 0.075));
  const margin = Math.max(6, Math.round(cellSize * 0.18));
  return {
    offsetX: cellSize / 2 - margin,
    offsetY: -cellSize / 2 + margin,
    radius
  };
}
